export type InviteShareResult = "shared" | "copied" | "unavailable";

async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Fall through to the legacy path for embedded or insecure contexts.
  }
  const ta = document.createElement("textarea");
  try {
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    ta.remove();
  }
}

export async function shareInviteLink(inviteUrl: string): Promise<InviteShareResult> {
  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share({
        title: "Join me on Dova",
        text: "Set up Dova before our first session — it takes about 5 minutes.",
        url: inviteUrl,
      });
    } catch {
      // Share sheet dismissal is not an error state for the caller.
    }
    return "shared";
  }

  return (await copyToClipboard(inviteUrl)) ? "copied" : "unavailable";
}
